import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail } from 'lucide-react';
import { useT } from './i18n';
export function Footer() {
  const t = useT();
  return <footer className="bg-brand-charcoal dark:bg-gray-950 text-white pt-24 pb-12 px-6 border-t border-gray-800 dark:border-gray-900 transition-colors duration-300" data-id="element-33" data-mp="2wg71lor2mcph">
      <div className="max-w-7xl mx-auto" data-id="element-34" data-mp="31h4g9rcvgom8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-24 mb-16" data-id="element-35" data-mp="3p42vymt63sj3">
          <div className="md:col-span-5 lg:col-span-4" data-id="element-36" data-mp="3u3pg7g7ey91e">
            <Link to="/" className="inline-block mb-6 group" data-id="element-37" data-mp="3u362kbosq6t6">
              <span className="font-sans font-extrabold text-3xl text-white tracking-tight group-hover:text-brand-green transition-colors" data-id="element-38" data-mp="3ffkyaeg6q1jo">
                Bairrou<span className="text-brand-green" data-id="element-39" data-mp="3kbt8ddfiz4jz">App</span>
                <span className="text-brand-yellow font-display text-4xl leading-none" data-id="element-40" data-mp="bx1f01fhi610">
                  !
                </span>
              </span>
            </Link>
            <p className="text-brand-yellow font-display text-2xl mb-4 transform -rotate-2" data-id="element-41" data-mp="3jfcody0ce14k">
              {t.common.tagline}
            </p>
            <p className="text-white/60 font-sans text-base leading-relaxed mb-8 max-w-sm" data-id="element-42" data-mp="3ehsxnymgjvvq">
              {t.footer.blurb}
            </p>
            <div className="flex gap-3" data-id="element-43" data-mp="3s9r421osbdo7">
              <a href="https://www.instagram.com/bairrouapp/" target="_blank" rel="noopener noreferrer" aria-label="BairrouApp no Instagram" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-brand-green hover:border-brand-green hover:text-white transition-all focus-visible:ring-2 focus-visible:ring-brand-green-light" data-id="element-44" data-mp="3ngy0hh51ybdp">
                <Instagram size={18} aria-hidden="true" data-id="element-45" data-mp="2gshin9m3ibk9" />
              </a>
              <a href="https://linkedin.com/company/bairrouapp" target="_blank" rel="noopener noreferrer" aria-label="BairrouApp no LinkedIn" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-brand-green hover:border-brand-green hover:text-white transition-all focus-visible:ring-2 focus-visible:ring-brand-green-light" data-id="element-46" data-mp="2gukkcqwm1t4t">
                <Linkedin size={18} aria-hidden="true" data-id="element-47" data-mp="updd9no8opi4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-7 lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8" data-id="element-48" data-mp="yp44fshoh7n6">
            <div data-id="element-49" data-mp="13mnt7mc052td">
              <h3 className="font-bold text-sm tracking-wider uppercase mb-6 text-white/40" data-id="element-50" data-mp="13m48jxuyw0bn">
                {t.footer.plataforma}
              </h3>
              <ul className="space-y-4" data-id="element-51" data-mp="1dd8p320ajt8l">
                <li data-id="element-52" data-mp="1dgcws9cyt740">
                  <Link to="/para-voce" className="text-white/70 hover:text-brand-green text-sm font-medium transition-colors" data-id="element-53" data-mp="1idmxil5t1575">
                    {t.nav.paraVoce}
                  </Link>
                </li>
                <li data-id="element-54" data-mp="36uwhbm6005uh">
                  <Link to="/para-negocio" className="text-white/70 hover:text-brand-green text-sm font-medium transition-colors" data-id="element-55" data-mp="32vfaaoaxb0n7">
                    {t.nav.paraNegocio}
                  </Link>
                </li>
                <li data-id="element-56" data-mp="2sz2la3qbpays">
                  <Link to="/para-marca" className="text-white/70 hover:text-brand-green text-sm font-medium transition-colors" data-id="element-57" data-mp="3ql06i8w37uef">
                    {t.nav.paraMarca}
                  </Link>
                </li>
                <li data-id="element-58" data-mp="3gtcb5wwett7o">
                  <Link to="/ods" className="text-white/70 hover:text-brand-green text-sm font-medium transition-colors" data-id="element-59" data-mp="3gsu5k9nuy2n3">
                    {t.nav.ods}
                  </Link>
                </li>
              </ul>
            </div>

            <div data-id="element-60" data-mp="8dk7dcn39hkl">
              <h3 className="font-bold text-sm tracking-wider uppercase mb-6 text-white/40" data-id="element-61" data-mp="3p2zwdt6af3xh">
                {t.footer.contato}
              </h3>
              <ul className="space-y-4" data-id="element-62" data-mp="3t5wjnx6rvo7r">
                <li data-id="element-63" data-mp="3f4k4hnzfrqmx">
                  <Link to="/contato" className="text-white/70 hover:text-brand-green text-sm font-medium transition-colors" data-id="element-64" data-mp="3f53k2y1m62xs">
                    {t.footer.faleConosco}
                  </Link>
                </li>
                <li data-id="element-65" data-mp="gmydigdgm5jh">
                  <a href="mailto:contato@bairrou.app" className="text-white/70 hover:text-brand-green text-sm font-medium transition-colors flex items-center gap-2" data-id="element-66" data-mp="gng6n44ts3n6">
                    <Mail size={16} data-id="element-67" data-mp="6vtzbivlyopp" />
                    contato@bairrou.app
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-white/40" data-id="element-68" data-mp="zdphf2eoh3qh">
          <p data-id="element-69" data-mp="2k20dmbr0xym2">{t.footer.direitos}</p>
          <div className="flex gap-8" data-id="element-70" data-mp="2f503npr20bpo">
            <a href="#" className="hover:text-white transition-colors" data-id="element-71" data-mp="2f3yujqtllzal">
              {t.footer.termos}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-72" data-mp="2svdb7r019oeh">
              {t.footer.privacidade}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}